import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';

function PropostaComercial() {
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case 'rejeitado':
                return '#d32f2f';
            case 'aguardando resposta':
                return '#ed6c02';
            case 'aprovado':
                return '#4caf50';
            default:
                return '#9e9e9e';
        }
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/propostacomercial/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados das Propostas:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="Propostas Comerciais"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel="Adicionar Proposta"
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/propostacomercial/cadastro"
            />

            <Grid container spacing={2}>
                {data.map((proposta, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card>
                            <CardActionArea component={Link} to={`/propostacomercial/${proposta.id}`}>
                                <Box sx={{ height: 6, bgcolor: getStatusColor(proposta.status) }} />
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{proposta.codigo}</Typography>
                                    <Typography variant="body2" color="text.secondary">{proposta.cliente}</Typography>
                                    <Typography variant="body2" color="text.secondary">Status: {proposta.status}</Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default PropostaComercial;
